import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AuditCheckCard = _resolveComponent("AuditCheckCard")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isVisible) = $event)),
    "hide-valid": true,
    title: _ctx.dialogTitle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "pa-5 ma-0",
        "data-cy": "AuditCheckDocumentDialog_Row"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditChecks, (auditCheck) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: auditCheck.check
            }, {
              default: _withCtx(() => [
                (auditCheck.count > 0)
                  ? (_openBlock(), _createBlock(_component_AuditCheckCard, {
                      key: 0,
                      onAuditCheckCardClicked: _ctx.onAuditCheckCardClicked,
                      auditCheckItemsCount: auditCheck.count,
                      auditCheckName: auditCheck.check,
                      shouldRedirectOnClick: true,
                      hasDarkBorder: true,
                      "data-cy": 'AuditCheckDocumentDialog_' + auditCheck.check + '_Card'
                    }, null, 8, ["onAuditCheckCardClicked", "auditCheckItemsCount", "auditCheckName", "data-cy"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}